import type { DnsFetchResponse } from './types';
import * as actionTypes from './actionTypes';

export const fetchDnsSetupRequest = () => ({
  type: actionTypes.FETCH_DNS_SETUP_REQUEST,
});

export const fetchDnsSetupError = () => ({
  type: actionTypes.FETCH_DNS_SETUP_ERROR,
});

export const fetchDnsSetupResponse = (response: DnsFetchResponse) => ({
  type: actionTypes.FETCH_DNS_SETUP_RESPONSE,
  response,
});
